import React from 'react';

export default function Intro() {
  return (
    <div className="hint-side">
      <h3>Tell the clients about you.</h3>
      <p className="form-hint">
        Add a profile image and a short bio to build a meaningful relationship
        with clients.
      </p>
    </div>
  );
}
